export default __webpack_public_path__ + "static/media/gas97.027e3957.svg";